import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getToken } from "../shared/utils/LocalSessionHandler";
import { LoggedInRouteProps } from "./interfaces";
import { ThisPaths } from "../shared/Constants";

// handle the private routes
const PublicRoute: React.FC<LoggedInRouteProps> = ({
    path,
    exact = false,
    component: Component,
}) => {
    return (
        <Route
            path={path}
            exact={exact}
            render={(props) =>
                !getToken() ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{ pathname: ThisPaths.MENU }} />
                )
            }
        />
    );
};

export default PublicRoute;
